import { useState } from "react";
import PatientProfileComponent from "../../../Patients/profile";
import cogoToast from "cogo-toast";

const VerbalOrderDetailItemComponent = ({ verbalOrderItem, onSubmitClick, isSubmitting }) => {

    const [checked, setChecked] = useState(false);

    const handleChange = () => {
        setChecked(!checked);
    };

    const handleOnSubmitClick = () => {
        if (!checked) {
            const { hide } = cogoToast.error(
                "Please select the checkbox to proceed.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            return;
        }
        onSubmitClick(verbalOrderItem);
        setChecked(false);
    }

    return (

        <div className="w-full h-full pt-4">
            <div className="flex flex-col w-full">
                <div className="flex flex-col gap-10 w-full">
                    <PatientProfileComponent item={verbalOrderItem} />
                </div>

                <div className="w-full p-4 flex flex-col gap-5">

                    <div className="flex flex-row gap-3">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    Drug Name
                                </label>
                            </div>
                            <div style={{ width: '10%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    :
                                </label>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{verbalOrderItem.drg}</label>
                        </div>
                    </div>

                    <div className="flex flex-row gap-3">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    SIG/Directions
                                </label>
                            </div>
                            <div style={{ width: '10%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    :
                                </label>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{verbalOrderItem.sig_direction}</label>
                        </div>
                    </div>

                    <div className="flex flex-row gap-3">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    Provider Name
                                </label>
                            </div>
                            <div style={{ width: '10%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    :
                                </label>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{verbalOrderItem.provider}</label>
                        </div>
                    </div>

                    <div className="flex flex-row gap-3">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    Verification Needed
                                </label>
                            </div>
                            <div style={{ width: '10%' }}>
                                <label className="text-xs md:text-sm ml-1 text-labelclr">
                                    :
                                </label>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{verbalOrderItem.verification}</label>
                        </div>
                    </div>

                    <div className="flex flex-row gap-3">
                        <div className="w-52 flex flex-row">
                            <div style={{ width: '90%', paddingRight: 10 }} className="text-right">
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={handleChange}
                                    className="h-5 w-5"
                                />
                            </div>
                            <div style={{ width: '10%' }}>
                            </div>
                        </div>
                        <div className="w-full">
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{verbalOrderItem.check_label}</label>
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <button
                            disabled={!checked || isSubmitting}
                            onClick={handleOnSubmitClick}
                            className={
                                !checked || isSubmitting
                                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                            }
                        >
                            SUBMIT
                        </button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default VerbalOrderDetailItemComponent;